export type AvailabilityInfo = {
  activityType: string;
  asSoonAsText: string;
  daysToAvailability: number;
  drivingMiles: number;
  isRestrictedLocation: boolean;
  localTimeZone: string;
  locationCity: string;
  locationState: string;
  routeId: string;
  secondsUntilCutoff: number;
  utcSoonestDateTimeIso: string;
};

export enum InventoryTypeId {
  Core = 1,
  WIP = 2,
  ThirdParty = 3,
  DealerMarketplace = 4
}

export interface VehiclePrice {
  total: number;
  totalDiscountAmount: number;
  discounts: { type: string; amount: number }[];
  monthlyPayment: number;
  downPayment: number;
  downPaymentDetails: {
    totalCashDue: number;
    additionalCashDown: number;
    nonRefundableShippingFees: number;
    tradeDown: number;
  };
  apr: number;
  term: number;
  transportCost: number;
  pricingErrorMessage?: string;
}

export interface MatchedFinance {
  downPayment?: number;
  monthlyPayment?: number;
}

export interface VehicleTag {
  tagId: number;
  tagCategoryId: number;
  tagKey: string;
  tagName: string;
  tagDescription: string;
  isResultTileDisplayable: boolean;
}

export interface DeliveryInfo {
  daysToDelivery: number;
  deliveryDate: string;
}

export type PartialAvailabilityInfo = Partial<
  Pick<
    AvailabilityInfo,
    | 'activityType'
    | 'asSoonAsText'
    | 'daysToAvailability'
    | 'utcSoonestDateTimeIso'
    | 'locationCity'
    | 'locationState'
    | 'routeId'
  >
>;

export type OverrideClassName<T> = T & { overrideClassName?: string };
